import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {FileCardList} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'div', '文件', 16, 'file-card-demo-size-label'),
            _$ce(2, 'div', (
                _$cc(FileCardList, {
                    'overflow': 'scrollX',
                    'items': [
                        {key: 'file-l', size: 'large', name: '品牌规范.pdf', byte: 1024 * 1024 * 1.8, src: 'https://example.com/brand-guide.pdf'},
                        {key: 'file-d', size: 'default', name: '品牌规范.pdf', byte: 1024 * 1024 * 1.8, src: 'https://example.com/brand-guide.pdf'},
                        {key: 'file-s', size: 'small', name: '品牌规范.pdf', byte: 1024 * 1024 * 1.8, src: 'https://example.com/brand-guide.pdf'},
                        {key: 'file-m', size: 'mini', name: '品牌规范.pdf', byte: 1024 * 1024 * 1.8, src: 'https://example.com/brand-guide.pdf'},
                    ]
                })
            ), 2, 'file-card-demo-size-list')
        ], 4, 'file-card-demo-size-row'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '图片', 16, 'file-card-demo-size-label'),
            _$ce(2, 'div', (
                _$cc(FileCardList, {
                    'overflow': 'scrollX',
                    'items': [
                        {key: 'img-l', size: 'large', name: '门店参考图.jpg', src: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80'},
                        {key: 'img-d', size: 'default', name: '门店参考图.jpg', src: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80'},
                        {key: 'img-s', size: 'small', name: '门店参考图.jpg', src: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80'},
                        {key: 'img-m', size: 'mini', name: '门店参考图.jpg', src: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80'},
                    ]
                })
            ), 2, 'file-card-demo-size-list')
        ], 4, 'file-card-demo-size-row'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '视频', 16, 'file-card-demo-size-label'),
            _$ce(2, 'div', (
                _$cc(FileCardList, {
                    'overflow': 'scrollX',
                    'items': [
                        {key: 'vid-l', size: 'large', name: '模型预览.mp4', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', poster: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80', videoProps: {muted: true, playsinline: true}},
                        {key: 'vid-d', size: 'default', name: '模型预览.mp4', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', poster: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80', videoProps: {muted: true, playsinline: true}},
                        {key: 'vid-s', size: 'small', name: '模型预览.mp4', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', poster: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80', videoProps: {muted: true, playsinline: true}},
                        {key: 'vid-m', size: 'mini', name: '模型预览.mp4', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', poster: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80', videoProps: {muted: true, playsinline: true}},
                    ]
                })
            ), 2, 'file-card-demo-size-list')
        ], 4, 'file-card-demo-size-row'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '音频', 16, 'file-card-demo-size-label'),
            _$ce(2, 'div', (
                _$cc(FileCardList, {
                    'overflow': 'scrollX',
                    'items': [
                        {key: 'aud-l', size: 'large', status: 'done', name: '品牌旁白.mp3', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'},
                        {key: 'aud-d', size: 'default', status: 'done', name: '品牌旁白.mp3', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'},
                        {key: 'aud-s', size: 'small', status: 'done', name: '品牌旁白.mp3', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'},
                        {key: 'aud-m', size: 'mini', status: 'done', name: '品牌旁白.mp3', src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'},
                    ]
                })
            ), 2, 'file-card-demo-size-list')
        ], 4, 'file-card-demo-size-row')
    ], 4, 'file-card-demo-size');
};